"use client";
import { Button } from "@/components/ui/Button";
import { Ellipse, YellowUnderLine } from "@/components/ui/Icon";
import { cdnDomain } from "@/constants/cdnUrls";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import clsx from "clsx";
import Image from "next/image";
import { useEffect, useState } from "react";

export default function AppBanner({
  translationNamespace = "common",
  className = "",
  showLogo = true,
  showDecorations = true,
  customTitle,
  customDescription,
  customButtonText,
  storeUrls = {
    android:
      "https://turna.go.link?adj_t=1yuvchll&adj_engagement_type=fallback_click",
    ios: "https://turna.go.link?adj_t=1yuvchll&adj_engagement_type=fallback_click",
  },
}) {
  const [storeUrl, setStoreUrl] = useState("#");
  const t = useTranslationDetector(translationNamespace);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      setStoreUrl(storeUrls.android);
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setStoreUrl(storeUrls.ios);
    } else {
      setStoreUrl(null); // desteklenmeyen cihaz
    }
  }, [storeUrls]);

  return (
    <div
      className={clsx(
        "bg-appbanner-gradient relative flex w-full flex-col items-center justify-center overflow-hidden rounded-lg md:h-[400px] md:flex-row lg:justify-between lg:pr-14 lg:pl-14",
        className,
      )}
    >
      <div
        className={clsx(
          "md:gap:0 flex flex-col items-center justify-center gap-6 p-6 pb-0 md:items-start md:p-0",
        )}
      >
        {showLogo && (
          <div className={clsx("relative hidden h-9 w-44 lg:block")}>
            <Image
              src="/images/dummy/turna-logo-size.png"
              alt="app-banner-logo"
              fill
              className={clsx("")}
            />
          </div>
        )}
        <div className={clsx("relative w-full")}>
          <h2
            className={clsx(
              "color-foreground text-xl-custom m-0 inline-flex flex-wrap justify-center gap-x-1 text-center leading-9 font-semibold md:max-w-[80%] md:justify-start md:text-left lg:text-4xl lg:leading-12",
            )}
          >
            {customTitle ? (
              <span>{customTitle}</span>
            ) : (
              <>
                <span>{t("appBannerTitle")}</span>
                <span className={clsx("relative")}>
                  {/* {t("appBannerTitleHighlight")} */}
                  <span
                    className={clsx(
                      "absolute bottom-[-10] left-1 w-full lg:left-2",
                    )}
                  >
                    <YellowUnderLine />
                  </span>
                </span>
                {/* <span>
                  {t("appBannerTitleHighlight2")}
                  {t("appBannerTitleEnd")}
                </span> */}
              </>
            )}
          </h2>
        </div>

        <p
          className={clsx(
            "text-primary-muted-subtext text-center text-base font-normal md:text-left lg:hidden",
          )}
        >
          {customDescription || t("appBannerDescriptionMobile")}
        </p>
        <p
          className={clsx(
            "text-primary-muted-subtext hidden text-center text-lg font-normal md:text-left lg:block",
          )}
        >
          {customDescription || t("appBannerDescriptionDesktop")}
        </p>
        <Button
          className={clsx("h-[50px] w-[251px] lg:hidden")}
          href={storeUrl}
          target="_blank"
        >
          {customButtonText || t("appBannerDownloadButton")}
        </Button>
      </div>

      <div
        className={clsx(
          "relative mt-8 flex h-full items-end justify-end md:mt-0",
        )}
      >
        <div>
          <Image
            src={`${cdnDomain}saka/common/app-banner.png`}
            alt="app-banner-device"
            width={563}
            height={510}
            className={clsx("h-auto w-full max-w-[375px] px-9 sm:px-0")}
          />
        </div>
      </div>

      {showDecorations && (
        <>
          <div
            className={clsx("absolute top-10 left-14 hidden h-2 w-2 lg:block")}
          >
            <Ellipse fillColor="transparent" className={clsx("h-2 w-2")} />
          </div>
          <div
            className={clsx(
              "absolute right-14 bottom-40 hidden h-2 w-2 xl:block",
            )}
          >
            <Ellipse fillColor="transparent" className={clsx("h-2 w-2")} />
          </div>
        </>
      )}
    </div>
  );
}
